import useProgressBarActions from '@/composables/progress/useProgressBarActions';
import { initCheckoutFlow, trackStatusViewed } from '@/composables/tracking/useConversionTracking';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

const progressBarActions = () => useProgressBarActions();

const startNftCheckoutFlowForLanding = (entryPoint) => {
  const orderStore = useOrderFormStore();
  initCheckoutFlow({
    entryPoint,
    paymentMethod: orderStore.getPaymentObject?.pspTypeCode ?? 'unknown',
    flowVersion: '1.0',
  });
};

const routes = [
  {
    path: '/nft',
    name: 'nft.order',
    component: () => import('@/views/nft/NFTOrderView.vue'),
    beforeEnter() {
      progressBarActions().resetAllProgress();
      startNftCheckoutFlowForLanding('nft_order');
    },
  },
  {
    path: '/nft/transit',
    name: 'nft.order.transit',
    component: () => import('@/views/nft/NFTOrderView.vue'),
    beforeEnter() {
      progressBarActions().resetAllProgress();
      startNftCheckoutFlowForLanding('nft_transit');
    },
  },
  {
    path: '/nft/status/:orderId',
    name: 'nft.summary',
    component: () => import('@/views/nft/NftSummaryView.vue'),
    beforeEnter() {
      progressBarActions().updateToComplete(['verification', 'identity', 'payment']);
      trackStatusViewed({ nft: true });
    },
  },
];

export default routes;
